import { useOverlays } from "contexts/OverlayContext";
import { MergeChartOfAccountsModal } from "./MergeChartOfAccountsModal";

export const MergeChartOfAccountsModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"mergeChartOfAccounts">(
        "mergeChartOfAccounts",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <MergeChartOfAccountsModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            account={overlayInfo.data.account}
        />
    );
};
